import { Component, OnInit, ViewChild, HostListener } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Location } from '@angular/common'
import { Bookmatch, Material } from '../../models';
import { GalleryComponent, GalleryState, ImageItem } from 'ng-gallery';
import { translatePos } from '../../components/image-viewer/image-viewer.component';
import { MaterialesService } from '../../services/materiales.service';
import { getLanguage, getLanguageFromUrl, Language } from 'src/app/language';
import { PinchZoomComponent } from 'ngx-pinch-zoom';
import { environment } from '../../../environments/environment';
// import { fromEvent } from 'rxjs';
// import { debounceTime } from 'rxjs/operators';

@Component({
  templateUrl: './bookmatch.container.html',
  styleUrls: ['./bookmatch.container.css']
})
export class BookmatchContainer implements OnInit {

  detalles: Bookmatch[] = [];
  zoom: number = 1;
  imgSrc: string = null;
  bloque: string;
  isZoom: boolean = false;
  allowGesture: boolean = true;
  currentDetalleIndex: number = 0;

  get language(): Language {
    return getLanguage(getLanguageFromUrl());
  }


  get currentDetalle(): Bookmatch {
    return this.detalles[this.currentDetalleIndex || 0];
  }
  @ViewChild(PinchZoomComponent) zoomComponent;
  @ViewChild(GalleryComponent) galleryComponent: GalleryComponent;

  constructor(
    private route: ActivatedRoute,
    private materialesService: MaterialesService,
    private location: Location
    ) {}


  getDownloadPath(path: string) {
    return environment.downloadBase + path;
  }

  galleryIndexChange(change: GalleryState) {
    translatePos.x = 0;
    this.zoom = 1;
    translatePos.y = 0;
    this.currentDetalleIndex = change.currIndex;
  }

  // mousewheel(evt:MouseWheelEvent) {
  //   const el: HTMLElement = document.querySelector('.zoom');
  //   if(evt.deltaY < 0){
  //     this.zoomIn();

  //   } else {
  //     this.zoomOut();
  //   }
  // }

  // @HostListener('wheel', ['$event'])
  // onMouseWheel(event: WheelEvent) {
  //   if(event.deltaY < 0){
  //     this.zoomIn();

  //   } else {
  //     this.zoomOut();
  //   }
  // }
  
  zoomIn(): void {
    if(!this.isZoom){
      this.zoomComponent.toggleZoom();
      this.isZoom = true;
    }
  }

  zoomOut(): void {
    if(!!this.isZoom){
      this.zoomComponent.toggleZoom();
      this.isZoom = false;
    }
  }

  tgglGesture() {
    this.galleryComponent.gestures = this.zoomComponent.isZoomedIn ? false : true;
  }

  back() {
    this.location.back();
  }


  ngOnInit(): void {
    // fromEvent(window,'onwheel').pipe(debounceTime(0)).subscribe(
    //   {
    //     next: ($event: WheelEvent) => {
    //       if($event.deltaY < 0){
    //         this.zoomIn();
      
    //       } else {
    //         this.zoomOut();
    //       }
    // }});
    // this.store.select(fromSelectors.selectDetalles).subscribe(detalles =>{
    //   if(this.query){
    //     this.detalles = [...detalles]
    //     this.imgs = this.detalles.map(d => new ImageItem({ src: d.IMAGENMINIURL, thumb: d.IMAGENMINIURL }));
    //     this.currentDetalleIndex = parseInt(this.query.index);
    //     setTimeout(() => {
    //       this.galleryComponent.set(parseInt(this.query.index));
    //     }, 100)
    //   }
    // });
    this.route.params.subscribe(async params => {
      try {
        this.bloque = params.bloque;
        this.detalles = await this.materialesService.getBookmatch(params.bloque).toPromise();
        //this.imgSrc = boockmatch[0].IMAGENURL;
        this.currentDetalleIndex = 0;
        setTimeout(() => {
              this.galleryComponent.set(this.currentDetalleIndex);
            }, 100)
      } catch (err) {
        console.log(err)
      }
    })
  }
}
